export default __webpack_public_path__ + "static/media/hnh2.332cf2ef.png";